import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { has as _has } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ActiveRouteName {

  public updatedRouteName: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public name: string;

  /**
   *
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  public constructor(router: Router, route: ActivatedRoute) {
    router.events.pipe(
      shareReplay(1),
    ).subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Traverse the active route tree
        let snapshot = route.snapshot;
        let activated = route.firstChild;
        if (activated != null) {
          while (activated != null) {
            snapshot = activated.snapshot;
            activated = activated.firstChild;
          }
        }

        // Some edge cases using params from the url to determine the routeName
        if (_has(snapshot.params, 'quizType')) {
          snapshot.data['routeName'] = snapshot.data['routeName'] + snapshot.params['quizType'];
        }

        // Try finding the 'stateName' from the data
        this.name = snapshot.data['routeName'] || 'unnamed';
        this.updatedRouteName.next(this.name);
      }
    });
  }

  /**
   * Determine whether names match
   *
   * @param {string} name
   * @returns {boolean}
   */
  public is(name: string): boolean {
    return this.name === name;
  }

  /**
   * Returns the current route name
   *
   * @returns {string}
   */
  public current(): string {
    return this.name;
  }
}
